import React, {useContext} from "react";
import {useTranslation} from 'react-i18next';
import UserContext from "../../hooks/UserContext";
import {useNavigate} from "react-router-dom";
import {Alert, AlertTitle, Button, Grid} from "@mui/material";
import {LOGIN} from "../../routes";

export const NotLoggedInWarning = () => {
  const { t } = useTranslation();
  const {user} = useContext(UserContext)
  const navigate =useNavigate()
  return (<>
    {!user || user.roles.includes("public") && (
      <Grid container sx={{marginY: '2rem'}}>
        <Alert severity="error">
          <AlertTitle>{t('auth.notLoggedIn.title')}</AlertTitle>
          {t('auth.notLoggedIn.message')}
          {' '}{t('auth.notLoggedIn.freeService')} <strong>{t('auth.notLoggedIn.free')}</strong> {t('auth.notLoggedIn.needIdentified')}
          <br/>
          <Button sx={{marginY: '2rem'}} color="primary" variant={"contained"} onClick={() => navigate(LOGIN)}>{t('auth.notLoggedIn.button')}</Button>
        </Alert>
      </Grid>
    )}
  </>)
}
